import { AuthTypes } from '../constants/authConstants';

const login = (user) => ({
    type: AuthTypes.LOGIN_AUTH,
    user, 
});

const logout = () => ({
    type: AuthTypes.LOGOUT_AUTH
});

const setOwnership = (isOwner) => ({
    type: AuthTypes.AUTH_SET_OWNERSHIP,
    isOwner
});

export default {
    login,
    logout,
    setOwnership
};